/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithCancelledDatetime
 */
export interface WithCancelledDatetimeOptional {
  /**
   *
   * @type {string}
   * @memberof WithCancelledDatetime
   */
  cancelledDatetime?: Date;
}

export interface WithCancelledDatetime extends WithCancelledDatetimeOptional {
  /**
   *
   * @type {string}
   * @memberof WithCancelledDatetime
   */
  cancelledDatetime?: Date;
}

export interface WithCancelledDatetimeTrackedI {
  /**
   *
   * @type {string}
   * @memberof WithCancelledDatetime
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
}

transformDatesMap.set(
  "WithCancelledDatetime",
  function (model: WithCancelledDatetime) {
    if (typeof model.cancelledDatetime == "string")
      model.cancelledDatetime = new Date(model.cancelledDatetime);
  },
);

export type WithCancelledDatetimeMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var WithCancelledDatetimeMeta: WithCancelledDatetimeMetaI =
  {} as WithCancelledDatetimeMetaI;
WithCancelledDatetimeMeta = typeMeta("WithCancelledDatetime", {
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = WithCancelledDatetimeMeta;

registerMeta(() => {});

export class WithCancelledDatetimeTracked implements WithCancelledDatetimeTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  constructor(config?: WithCancelledDatetimeOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithCancelledDatetimeOptional,
    options?: AssignOptions,
  ): WithCancelledDatetimeTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithCancelledDatetimeTrackedI {
    const cloned = {} as WithCancelledDatetimeTrackedI;
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithCancelledDatetimeTrackedI {
    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    return this;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithCancelledDatetimeMeta.cancelledDatetime,
      WithCancelledDatetimeMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
